import { PersonIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";

import api from '../../lib/api';
import { toast } from '../ui/use-toast';

const ChangeSuperadminDialog = ({ user, fetchClubMembers }) => {

    const [isLoading, setIsLoading] = useState(false);
    const role = user.superadmin;

    const { behaviour } = role === false
        ? { behaviour: 'promote' }
        : { behaviour: 'demote' };

    const handleChange = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/superadmins/${behaviour}`, {
                targetUserId: user.id,
            });

            fetchClubMembers();
            toast({
                title: 'Användares superadministratörsstatus ändrad',
                description: role ? `${user.first_name} ${user.last_name} blev borttagen som superadministratör. Be användaren logga ut och in igen för att se ändringarna.` : `${user.first_name} ${user.last_name} blev tillagd som superadministratör. Be användaren logga ut och in igen för att se ändringarna.`,
            });
            setIsLoading(false);
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog>
            <DropdownMenuItem
                className='w-full'
                onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <PersonIcon className='mr-3' />
                    {role ? 'Ta bort som superadministratör' : 'Gör till superadministratör'}
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        Ändra superadministratörsstatus för {user.first_name} {user.last_name}
                    </DialogTitle>
                    <DialogDescription>
                        {role ? `Är du helt säker på att du vill ta bort ${user.first_name} ${user.last_name} som superadministratör?` :
                            `Är du helt säker på att du göra ${user.first_name} ${user.last_name} till superadministratör?`}
                    </DialogDescription>
                </DialogHeader>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button className='h-full' type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button className='whitespace-normal h-fit' variant='destructive' onClick={handleChange} disabled={isLoading}>
                        {role ? 'Ta bort som superadministratör' : 'Gör till superadministratör'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ChangeSuperadminDialog;
